<template>
    <nav class="panel">
        <p class="panel-heading">
            New & Unsigned clients
        </p>
        <VuePerfectScrollbar class="scroll-area" :settings="settings" @ps-scroll-y="scrollHandle">

        </VuePerfectScrollbar>
    </nav>
</template>

<script>
    import VuePerfectScrollbar from 'vue-perfect-scrollbar'
    export default {
        components: {
            VuePerfectScrollbar: VuePerfectScrollbar
        },
        data() {
            return {
                settings: {
                    maxScrollbarLength: 60
                },
                threads: []
            }
        },
        methods: {
            scrollHandle(evt) {

            }
        },
    }
</script>

<style scoped>
    .scroll-area {
        max-height: 208px;
    }
    small {
        font-size: 12px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Manager/UnsignedClients.vue